export * from "./errors";

export type Ratio = "4 / 5" | "3 / 4" | "1 / 1" | "1.91 / 1" | "9 / 16" | "16 / 9";

export const CAROUSEL_RATIOS: readonly Ratio[] = ["4 / 5", "3 / 4", "1 / 1", "1.91 / 1", "9 / 16"];
export const MAX_SLIDES = 20;
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 50 * 1024 * 1024;
export const MAX_TOTAL_BYTES = 250 * 1024 * 1024;
export const MAX_VIDEO_SECONDS = 60;
export const MAX_CAPTION_CHARS = 2200;
export const CAPTION_PREVIEW_CHARS = 125;

export type UploadAssetSpec = {
  name: string;
  type: string;
  size: number;
  kind: "image" | "video";
  duration?: number;
  sourceRatio?: Ratio;
};

export type PreviewSlideSeed = {
  kind: "image" | "video";
  url: string;
  name: string;
  sourceRatio?: Ratio;
};

export type PreviewSeed = {
  username: string;
  location: string;
  caption: string;
  likes: string;
  ratio: Ratio;
  slides: PreviewSlideSeed[];
  avatarUrl: string | null;
};

export type StoredPreview = Omit<PreviewSeed, "slides" | "avatarUrl"> & {
  slides: Array<{
    kind: "image" | "video";
    name: string;
    key: string;
  }>;
  avatarKey: string | null;
};

export type PreviewHistoryItem = PreviewSeed & {
  id: string;
  createdAt: string;
  expiresAt: string;
  previewUrl: string;
};
